const INITIAL_STATE = {
  messageAssignedToMe: {},
  serviceTypeCollection: {},
  auditTrail: {},
  scheduleService: {},
  groupList: {},
  errors: {},

}
const dashboard = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_MESSAGE_ASSIGNED_TO_ME':
    return { ...INITIAL_STATE, messageAssignedToMe: action.data }
  case 'GET_MESSAGE_ASSIGNED_TO_ME_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  case 'GET_SERVICE_TYPE_COLLECTION':
    return { ...INITIAL_STATE, serviceTypeCollection: action.data }
  case 'GET_SERVICE_TYPE_COLLECTION_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  case 'GET_AUDIT_TRAIL':
    return { ...INITIAL_STATE, auditTrail: action.data }
  case 'GET_AUDIT_TRAIL_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  case 'GET_SCHEDULE_SERVICE':
    return { ...INITIAL_STATE, scheduleService: action.data }
  case 'GET_SCHEDULE_SERVICE_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  case 'GET_GROUP_LIST_SUCCESSFULLY':
    return { ...INITIAL_STATE, groupList: action.data }
  case 'GET_GROUP_LIST_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};

export default dashboard;